<template>
  <div class="banner-with-logo">
    <transition name="fade">
      <h2 v-if="showDefault">
        <slot />
      </h2>
    </transition>
    <transition name="fade">
      <h2 v-if="!showDefault">
        <slot name="second" />
      </h2>
    </transition>
    <img src="@/assets/svg/icons/banner-logo.svg" alt="">
  </div>
</template>

<script>
  export default {
    name: 'BannerWithLogo',
    props: {
      animated: {
        type: Boolean,
        default: false,
      },
      timeout: {
        type: Number,
        default: 3000
      }
    },
    data() {
      return {
        showDefault: true,
        interval: null
      };
    },
    methods: {
      initIterval() {
        this.interval = setInterval(() => {
          this.showDefault = !this.showDefault;
        }, this.timeout);
      },
      stopInterval() {
        clearInterval(this.interval);
      }
    },
    mounted() {
      if (this.animated)
        this.initIterval();
    },
    destroyed() {
      this.stopInterval();
    },
  };
</script>

<style scoped lang="scss">
  .banner-with-logo {
    position: relative;
    background-color: $green;
    padding: 14px 32px 120px 32px;
    max-width: 577px;
    min-height: 316px;

    h2 {
      position: absolute;
      left: 32px;
      top: 14px;
      font-weight: 700;
      font-size: 54px;
      line-height: 62px;
      color: $white;

      &::v-deep(span) {
        color: $green;
        background-color: $white;
        padding: 0 5px;

        span {
          background-color: unset;
          padding: 0;
          display: inline-block;
          transform: translateY(-4px);
        }
      }
    }

    img {
      position: absolute;
      margin-left: auto;
      height: 77px;
      bottom: 0;
      right: 50px;
    }
  }
  @media (max-width: 768px) {
    .banner-with-logo {
      min-height: 263px;

      h2 {
        font-size: 40px;
        line-height: 49px;
      }

    }
  }
  @media (max-width: 489px) {
    .banner-with-logo {
      padding: 14px 32px 90px 14px;

      h2 {
        left: 14px;
        top: 14px;
      }

      img {
        height: 63px;
        right: 38px;
      }
    }
  }
</style>
